import { BankAccountDetailSection } from "bankaccount/BankAccountDetailSection";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import BankAccountOptionsPanel from "./BankAccountOptionsPanel";

export const BankAccountDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.BankAccountDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <BankAccountDetailSection
            bankAccount={viewModel.bankAccount}
            selectedBookkeepingIds={viewModel.bookkeepingIds}
            availableBookkeepings={viewModel.availableBookkeepings}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <BankAccountOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            existingBankAccount={viewModel.bankAccount}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>
}